import { Box, Stack, Typography } from '@mui/material';
import { Suspense } from 'react';
import SearchBox from '../../../core-components/theme/components/Searchbox/Searchbox';
import QueryErrorBoundary from '../../../globalComponents/ErrorBoundary';
import Loader from '../../../globalComponents/loader/DPLoader';
import { useDebouncedSearchParam } from '../../../hooks/useDebouncedSearchParam';
import AddLogbookTemplateButtonAndModal from './AddLogbookTemplateButtonAndModal';
import LogbookTemplateTable from './LogBookTemplateTable';

function LogbookTemplatesContent() {
    const { searchValue, inputRef, handleSearch } = useDebouncedSearchParam();

    return (
        <>
            <SearchBox
                id='search'
                placeholder="Search logbook templates"
                onSearch={handleSearch}
                onClear={() => handleSearch('')}
                onChange={(e) => handleSearch(e.target.value)}
                ref={inputRef}
                defaultValue={searchValue}
            />

            <Box width="100%" height='80%'>
                <QueryErrorBoundary>
                    <Suspense fallback={<Loader height="100%" />}>
                        <LogbookTemplateTable
                            searchString={searchValue}
                        />
                    </Suspense>
                </QueryErrorBoundary>
            </Box>
        </>
    );
}

export default function LogbookTemplates() {
    return (
        <Box height='100%'>
            <Stack height='100%' direction="column" spacing={3}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant='title'>Logbook Templates</Typography>
                    <AddLogbookTemplateButtonAndModal />
                </Stack>

                <LogbookTemplatesContent />
            </Stack>
        </Box>
    );
}